// src/pages/VerifyEmailPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { API } from '../services/api';
import './VerifyEmailPage.css';

const VerifyEmailPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  // Logo path - using the same logo as Header
  const PUBLIC_IMAGE_ROOT = process.env.PUBLIC_URL || '';
  const LOGO_PATH = `${PUBLIC_IMAGE_ROOT}/images2/Logos AWD/Horizontal/Colored_no_background.png`;

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        console.log(`Verifying token with API: /auth/verify-email/${token}`);

        const response = await API.get(`/auth/verify-email/${token}`);

        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message || 'Email successfully verified!');

          // Update user data in localStorage if exists
          if (response.data.user) {
            const existingUserData = localStorage.getItem('userData');
            if (existingUserData) {
              localStorage.setItem('userData', JSON.stringify(response.data.user));
            }
          }

          // Redirect to dashboard after 3 seconds
          setTimeout(() => {
            navigate('/dashboard');
          }, 3000);
        }
      } catch (error) {
        console.error('Error during verification:', error);
        setStatus('error');
        setMessage(
          error.response?.data?.error ||
          'The verification link is invalid or has expired.'
        );
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, navigate]);

  return (
    <div className="verify-email-page">
      {/* Logo at top right */}
      <img
        src={LOGO_PATH}
        alt="AWD Logo"
        className="verify-email-logo"
      />

      <div className="verify-email-content">
        <div className="verify-email-card">
          {status === 'verifying' && (
            <>
              <div className="status-icon verifying">
                <div className="spinner" />
              </div>
              <h2 className="verify-email-title verifying">
                Verifying...
              </h2>
              <p className="verify-email-message">
                Please wait while we verify your email.
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="status-icon success">
                ✓
              </div>
              <h2 className="verify-email-title success">
                Email successfully verified
              </h2>
              <p className="verify-email-message">
                {message}
              </p>
              <p className="verify-email-redirect">
                Redirecting to the dashboard...
              </p>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="status-icon error">
                ✕
              </div>
              <h2 className="verify-email-title error">
                Verification Error
              </h2>
              <p className="verify-email-message">
                {message}
              </p>
              <Link to="/login" className="verify-email-button">
                Back to Login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;